import { idpService } from 'services/api/identity-provider.service';
import { putStoredStatus } from 'shared-state/identity/statusPersistence';
import { LobbyRedirectReason, setLobbyRedirect } from './lobbyRedirect';

/**
 * Persists OOO Today to IndexedDB and backend, then redirects to lobby.
 * IndexedDB is written before redirect so StatusPersistenceProvider restore
 * does not resurrect a stale "away" status after reload.
 */
export async function persistOooTodayAndRedirectToLobby(userId: string, todayStr: string, reason: LobbyRedirectReason): Promise<void> {
    try {
        await putStoredStatus({
            userId,
            status: 'out-of-office',
            location: null,
            phrase: null,
            duration: null,
            endTime: null,
            returnDate: todayStr,
            returnTime: null,
            absenceComment: null,
            emergencyContact: null,
            version: 1
        });
    } catch (err: unknown) {
        console.error('[OOO Lobby Redirect] Failed to persist status to IndexedDB:', err);
    }

    try {
        await idpService.updateUser(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            status: 'out-of-office',
            returnDate: todayStr,
            returnTime: null,
            absenceComment: null
        });
    } catch (err: unknown) {
        console.error('[OOO Lobby Redirect] Failed to persist OOO status to backend:', err);
    }

    setLobbyRedirect(reason, true);
    window.location.href = '/dashboard';
}
